var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"bottom-right",class:{'is-visible': _vm.visible},on:{"click":_vm.scrollTop}},[_c('i',{staticClass:"fas fa-arrow-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }